export default __webpack_public_path__ + "static/media/ArrowLeftTeal.20c6fa41.svg";